import { BaseModel } from 'app/core/models/base.model';
import { Shipment } from '../shipment/shipment';
import { PartRequest } from 'app/partRequest/partRequest';

export class ShipmentItem extends BaseModel {
	partRequest: PartRequest;
	shipment: Shipment;
}
